import { Autocomplete, SxProps, TextField, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlPlannerV2VisitSimplifiedStatus } from "~/__generated__";

type Props = {
    value: GqlPlannerV2VisitSimplifiedStatus | null;
    onChange: (value: GqlPlannerV2VisitSimplifiedStatus | null) => void;
    sx?: SxProps<Theme>;
};

export default function PlannerVisitSimplifiedStatusSelect({ value, onChange, sx }: Props) {
    const { t } = useTranslation("planner");

    const options = Object.values(GqlPlannerV2VisitSimplifiedStatus).map(status => ({
        value: status,
        label: t(`PlannerVisitSimplifiedStatusSelect.visitStatusValue.${status}`),
    }));

    return (
        <Autocomplete
            size="small"
            sx={sx}
            options={options}
            value={options.find(option => option.value === value) ?? null}
            onChange={(_, newValue) => onChange(newValue?.value ?? null)}
            getOptionLabel={option => option.label}
            getOptionKey={option => option.value}
            isOptionEqualToValue={(option, val) => option.value === val.value}
            renderInput={params => (
                <TextField {...params} label={t("PlannerVisitSimplifiedStatusSelect.labelStatus")} variant="outlined" />
            )}
        />
    );
}
